import type {
  AssetRow,
  EnhanceTaggingRow,
  ImpactAssessmentRow,
} from "./types";

/** Prototype rows aligned with the Impact Assessment design mock. */
export const MOCK_IMPACT_ROWS: ImpactAssessmentRow[] = [
  {
    id: "b0",
    dimension: "Department",
    tagValue: "Quality",
    triggeredBy: "System",
    analysis:
      "References batch release and quality control testing requirements throughout the operative text, spanning incoming material inspection, in-process controls, finished product release testing, and the batch disposition decision tree used before market release.",
    summary:
      "Directly affects Quality Control testing and batch disposition procedures.",
    recommendation: "High-confidence department match — keep as tagged.",
    impactLabel: "Impacted",
    impactBg: "#FEE2E2",
    impactColor: "#991B1B",
    hasImpact: true,
    submissions: [],
  },
  {
    id: "b1",
    dimension: "Department",
    tagValue: "Safety",
    triggeredBy: "System",
    analysis:
      "'Adverse event' and 'pharmacovigilance' occur 9x including a dedicated reporting timeline table, with explicit expedited and periodic reporting clocks, a signal detection cadence, and escalation thresholds tied to seriousness and causality classification.",
    summary:
      "Sets mandatory adverse event reporting and signal detection obligations.",
    recommendation: "Strong, consistent match — no reviewer action needed.",
    impactLabel: "Impacted",
    impactBg: "#FEE2E2",
    impactColor: "#991B1B",
    hasImpact: true,
    submissions: [],
  },
  {
    id: "b2",
    dimension: "Market",
    tagValue: "European Union",
    triggeredBy: "System",
    analysis:
      "'Labelling' and 'package leaflet' occur 14x including a dedicated requirements table, covering mock-up submission timing, national language annex rules, and the readability testing obligations that apply before any pack redesign can be printed.",
    summary: "Sets mandatory label content and multilingual leaflet rules.",
    recommendation: "Strong, consistent match — no reviewer action needed.",
    impactLabel: "Impacted",
    impactBg: "#FEE2E2",
    impactColor: "#991B1B",
    hasImpact: true,
    submissions: [],
  },
  {
    id: "b3",
    dimension: "Topics",
    tagValue: "Labelling",
    triggeredBy: "System",
    analysis:
      "Single mention in an annex footnote referencing an older labelling guideline; no substantive clauses in the body, no defined obligations, and no cross-reference to the main operative articles.",
    summary: "–",
    recommendation:
      "Likely out of scope — delete unless a manufacturing SME confirms.",
    impactLabel: "Impacted",
    impactBg: "#FEE2E2",
    impactColor: "#991B1B",
    hasImpact: true,
    submissions: [],
  },
  {
    id: "b4",
    dimension: "Topics",
    tagValue: "Manufacturing",
    triggeredBy: "System",
    analysis: "–",
    summary: "–",
    recommendation: "–",
    impactLabel: "",
    impactBg: "",
    impactColor: "",
    hasImpact: false,
    submissions: [],
  },
];

export const MOCK_ENHANCE_ROWS: EnhanceTaggingRow[] = [
  {
    id: "e0",
    dimension: "Priority",
    tagValue: "High",
    ruleId: "12",
    matchingCondition:
      "Product Type = Large Molecule and Topic = Safety Concern and Health Authority = FDA",
  },
  {
    id: "e1",
    dimension: "Ingredient",
    tagValue: "China LOC",
    ruleId: "35",
    matchingCondition: "If country = China and Product Type = Biosimilar",
  },
  {
    id: "e2",
    dimension: "Topic",
    tagValue: "Pharmacovigilance",
    ruleId: "18",
    matchingCondition:
      "If Health Authority = EMA and Topic = Labeling Update",
  },
  {
    id: "e3",
    dimension: "Health Authority",
    tagValue: "NMPA",
    ruleId: "27",
    matchingCondition: "If Market = EU and Product Type = Biologic",
  },
];

export const MOCK_ASSET_ROWS: AssetRow[] = [
  {
    rank: 1,
    title: "SOP — Quality Control Testing",
    subtitle: "SOP-QC-2024-001 · V2.0 · Tags Verified",
    status: "Completed",
    tags: ["Small Molecule", "European Union", "Manufacturing"],
    score: "2/3",
    relevance: "High",
    relBg: "#DCFCE7",
    relColor: "#166534",
  },
  {
    rank: 2,
    title: "SOP — Batch Release Procedure",
    subtitle: "SOP-BR-2024-003 · V1.0 · Tags Verified",
    status: "Completed",
    tags: ["Small Molecule", "Manufacturing"],
    score: "1/3",
    relevance: "Medium",
    relBg: "#FEF3C7",
    relColor: "#92400E",
  },
  {
    rank: 3,
    title: "SOP — Stability Study Protocol",
    subtitle: "SOP-SS-2024-007 · V3.0 · Tags Verified",
    status: "Completed",
    tags: ["Manufacturing"],
    score: "0/3",
    relevance: "Low",
    relBg: "#FEE2E2",
    relColor: "#991B1B",
  },
  {
    rank: 4,
    title: "SOP — Deviation Handling",
    subtitle: "SOP-DH-2024-012 · V1.0 · Tags Verified",
    status: "Completed",
    tags: ["Manufacturing"],
    score: "0/3",
    relevance: "Low",
    relBg: "#FEE2E2",
    relColor: "#991B1B",
  },
];

/** Demo submitter shown in the design modal. */
export const DEMO_ASSESSOR = {
  name: "Sarah Sui",
  initials: "SS",
  avatarBg: "#1447E6",
};
